import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { HttpClientModule, HttpClient } from "@angular/common/http";
import {
  TranslateLoader,
  TranslateModule,
  TranslateService,
} from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { TranslateConfigService } from "../../../theme/home/translateConfig.service";
import { SafePipe } from "../../../_Pipes/safe.pipe";
import { NewBidDetailsComponent } from "./new-bid-details.component";
import { SharedComponentModule } from "../../shared.module";
import { PrintFormatsModule } from "../../../print-formats/print-formats.module";
import { TabViewModule } from "primeng/tabview";
import { AccordionModule } from "primeng/accordion";
import { PrintFormatsNewComModule } from "../../../print-formats-new/print-formats-new.module";
// For Translator

// AoT requires an exported function for factories
export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/translator/", ".txt");
}
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    HttpClientModule,
    SharedComponentModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    PrintFormatsModule,
    TabViewModule,
    AccordionModule,
    PrintFormatsNewComModule
  ],
  providers: [TranslateConfigService],
  declarations: [NewBidDetailsComponent,],
  exports: [NewBidDetailsComponent,],
})
export class NewBidDetailModule { }
